import React, { PropsWithChildren } from 'react';

import { ErrorPage } from './main-view';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import logger from './logging';

const errorBoundaryLogger = logger('error-boundary');

// Even though we have an [error boundary](https://www.npmjs.com/package/react-error-boundary) we still need to handle
// some errors ourselves, namely errors during async code + event handlers
window.addEventListener('error', (err: ErrorEvent) => {
  errorBoundaryLogger.error(
    { err: err.error, strErrorMessage: err.message, strCurrentUrl: window.location.href, context: err },
    'Uncaught error',
  );
});

window.addEventListener('unhandledrejection', (err: PromiseRejectionEvent) => {
  errorBoundaryLogger.error(
    { err: err.reason, strCurrentUrl: window.location.href, context: err },
    'Unhandled promise rejection',
  );
});

export const ErrorBoundary = ({ children }: PropsWithChildren<unknown>) => {
  return (
    <ReactErrorBoundary
      onError={(err: Error, info: { componentStack: string }) => {
        errorBoundaryLogger.error(
          { err, strComponentStack: info.componentStack, strCurrentUrl: window.location.href },
          'Error caught by error boundary',
        );
      }}
      fallback={<ErrorPage displayError={undefined} />}
    >
      {children}
    </ReactErrorBoundary>
  );
};
